import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      const dest = location.state?.from || (user.role === "admin" ? "/admin" : "/dashboard");
      navigate(dest);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:block relative bg-emerald-950 emerald-grain">
        <img src="/hero-us.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative z-10 p-12 flex flex-col h-full justify-between">
          <Link to="/" className="flex items-center gap-2.5 text-white font-display font-extrabold text-xl">
            <span className="h-9 w-9 rounded-xl overflow-hidden"><img src="/logo.png" alt="logo" className="h-full w-full object-cover scale-[1.18]" /></span>
            Accurate Auto Rentals
          </Link>
          <div>
            <h2 className="font-display text-4xl font-extrabold text-white leading-tight">Your next journey starts here.</h2>
            <p className="mt-4 text-emerald-100/70 max-w-sm">Sign in to manage your bookings and drive away in minutes.</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h1 className="font-display text-3xl font-extrabold text-emerald-950">Sign in</h1>
          <p className="mt-2 text-slate-500 text-sm">Welcome back. Enter your details.</p>

          <div className="mt-8 space-y-4">
            <div>
              <Label className="text-slate-600">Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1.5 h-11 border-slate-200" placeholder="you@example.com" />
            </div>
            <div>
              <Label className="text-slate-600">Password</Label>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1.5 h-11 border-slate-200" placeholder="••••••••" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid="login-submit" className="mt-6 w-full h-11 bg-emerald-900 hover:bg-emerald-800 rounded-xl">
            {loading ? <Loader2 className="animate-spin" /> : "Sign in"}
          </Button>

          <p className="mt-6 text-center text-sm text-slate-500">
            No account?{" "}
            <Link to="/register" className="text-emerald-700 font-semibold" data-testid="go-register">Create one</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
